module.exports = __webpack_public_path__ + "img/OT526.f030a61.webp";